module.exports = __webpack_public_path__ + "media/hallBgm.b8de6840.mp3";